import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import path from 'path';

// ----------------------------------------------------------------------

// OVERVIEW

// Job Position
const JobPositionListPage = lazy(() => import('src/sections/job_position/job-position-index'));
const JobPositionShowPage = lazy(() => import('src/pages/dashboard/job_position/show'));
const JobPositionNewPage = lazy(() => import('src/sections/job_position/new/job-position-new'));

// Interviews
const InterviewEditPage= lazy(() => import('src/sections/interviews/interviews-edit'));

// Applicants
const ApplicantListPage = lazy(() => import('src/sections/applicant/list'));
const ApplicantShowPage = lazy(() => import('src/sections/applicant/show'));

const UserListPage = lazy(() => import('src/sections/user/list'));

const AccountView = lazy(() => import('src/sections/account/view/user-account-view'));

// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        path: 'job_positions',
        children: [
          { element: <JobPositionListPage />, index: true },
          { path: ':id', element: <JobPositionShowPage/> },
          { path: 'new', element: <JobPositionNewPage />}
        ],
      },
      {
        path: 'account',
        children: [
          { element: <AccountView />, index: true },
        ],
      },
      {
        path: 'interviews',
        children: [
          { element: <InterviewEditPage />, index: true }
        ],
      },
      {
        path: 'applicants',
        children: [
          { element: <ApplicantListPage />, index: true },
          { path: ':id', element: <ApplicantShowPage />}
        ],
      },
      {
        path: 'users',
        children: [
          { element: <UserListPage />, index: true }
        ],
      }

    ],
  },
];
